import React from 'react';

interface ArrowBackIconProps {
    className?: string;
    style?: React.CSSProperties;
}

export const ArrowBackIcon: React.FC<ArrowBackIconProps> = ({className, style}) => (
    <svg
        width="21"
        height="15"
        viewBox="0 0 21 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={style}
    >
        <path
            d="M0.292893 6.65691C-0.0976314 7.04743 -0.0976315 7.68059 0.292892 8.07112L6.65685 14.4351C7.04738 14.8256 7.68054 14.8256 8.07107 14.4351C8.46159 14.0446 8.46159 13.4114 8.07107 13.0209L2.41421 7.36401L8.07107 1.70716C8.46159 1.31663 8.46159 0.683469 8.07107 0.292945C7.68054 -0.0975797 7.04738 -0.0975797 6.65686 0.292945L0.292893 6.65691ZM21 7.36401L21 6.36401L1 6.36401L1 7.36401L1 8.36401L21 8.36401L21 7.36401Z"
            fill="currentColor"
            fillOpacity="0.9"
        />
    </svg>
);
